import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotreMission() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar onCreateClick={() => { }} createLabel="Publier" />

      <section className="relative w-full overflow-hidden bg-primary-500">
        <div className="px-4 md:px-8 py-[1.5rem] md:py-20">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/20 text-white text-sm font-medium">
              <i className="ri-heart-3-line"></i>
              Notre mission
            </span>
            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-semibold text-white leading-tight">
              Créer du lien entre les habitants du Grand Dole
            </h1>
            <p className="mt-4 text-lg md:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
              Yonyon est né d'un constat simple : il y a plein de gens formidables autour de nous, mais on ne se croise pas.
            </p>
          </div>
        </div>
      </section>

      <main className="flex-1 w-full px-4 md:px-8 py-10 md:py-14">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white border border-background-200 rounded-lg p-6 md:p-10">
            <section>
              <h2 className="font-semibold text-foreground-950">
                Pourquoi cette appli ?
              </h2>

              <p className="text-foreground-500 mt-3">
                Dans le Grand Dole, entre communes, villages et quartiers, beaucoup de
                personnes ont envie de bouger, partager et s'entraider sans toujours
                savoir comment se rencontrer.
              </p>

              <p className="text-foreground-500 mt-3">
                Yonyon est né d’un constat simple : on vit les uns à côté des autres, mais on ne se rencontre pas toujours.
              </p>
            </section>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-primary-50 flex items-center justify-center text-primary-600">
                  <i className="ri-map-pin-2-line text-2xl"></i>
                </div>
                <h3 className="mt-3 font-semibold text-foreground-950 text-sm">De la proximité</h3>
                <p className="mt-1 text-sm text-foreground-500">
                  Des activités, des initiatives et des échanges près de chez toi. Pas besoin d’aller loin, juste du lien local.
                </p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-primary-50 flex items-center justify-center text-primary-600">
                  <i className="ri-hand-heart-line text-2xl"></i>
                </div>
                <h3 className="mt-3 font-semibold text-foreground-950 text-sm">De l'entraide</h3>
                <p className="mt-1 text-sm text-foreground-500">
                  Besoin d’un coup de main ou envie d’aider ? Demande de l’aide, partage une compétence ou propose simplement un peu de ton temps.
                </p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-primary-50 flex items-center justify-center text-primary-600">
                  <i className="ri-chat-smile-3-line text-2xl"></i>
                </div>
                <h3 className="mt-3 font-semibold text-foreground-950 text-sm">De la bienveillance</h3>
                <p className="mt-1 text-sm text-foreground-500">
                  Le Coin, c’est l’espace pour échanger, poser une question, partager une info ou discuter avec les gens autour de toi, dans la bienveillance.
                </p>
              </div>
            </div>

            <h2 className="mt-12 font-heading text-2xl font-semibold text-foreground-950">
              Nos valeurs
            </h2>
            <div className="mt-4 space-y-4">
              <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50 border border-background-100">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 shrink-0 text-sm font-bold">1</span>
                <div>
                  <h3 className="font-semibold text-foreground-950 text-sm">Ouvert à tous</h3>
                  <p className="text-sm text-foreground-500 mt-0.5">Que tu viennes pour sortir, bouger, donner un coup de main ou simplement découvrir ce qui se passe autour de toi, chacun peut trouver sa place.</p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50 border border-background-100">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 shrink-0 text-sm font-bold">2</span>
                <div>
                  <h3 className="font-semibold text-foreground-950 text-sm">
                    Accessibilité
                  </h3>
                  <p className="text-sm text-foreground-500 mt-0.5">
                    L'application a vocation à rester accessible au plus grand nombre.
                    Notre priorité : faciliter les activités, l'entraide et les échanges
                    entre les personnes qui vivent autour de toi.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50 border border-background-100">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 shrink-0 text-sm font-bold">
                  3
                </span>
                <div>
                  <h3 className="font-semibold text-foreground-950 text-sm">
                    Respect
                  </h3>
                  <p className="text-sm text-foreground-500 mt-0.5">
                    Chacun s'engage à respecter les autres. La modération et les
                    signalements permettent de préserver un espace convivial,
                    bienveillant et sûr.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50 border border-background-100">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 shrink-0 text-sm font-bold">
                  4
                </span>
                <div>
                  <h3 className="font-semibold text-foreground-950 text-sm">
                    Confidentialité
                  </h3>
                  <p className="text-sm text-foreground-500 mt-0.5">
                    Tes données personnelles ne sont pas revendues. Yonyon utilise la localisation des activités et des publications pour te proposer ce qui se passe autour de toi.
                    Ta position personnelle n'est pas affichée publiquement.
                    Nous limitons les informations visibles à ce qui est nécessaire au fonctionnement de l' application.
                  </p>
                </div>
              </div>
            </div>

            <h2 className="mt-12 font-heading text-2xl font-semibold text-foreground-950">
              Qui sommes-nous ?
            </h2>
            <p className="mt-3 text-foreground-700 leading-relaxed">
              Yonyon est un projet citoyen, porté par des habitants du Grand Dole
              convaincus que la proximité et la bienveillance font la différence au quotidien.
              Nous ne sommes pas une entreprise, nous sommes des voisins qui croient en leurs
              quartiers. L' application est développée et maintenue localement, avec des outils
              modernes et une approche éthique.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
              <Link
                to="/"
                className="px-5 py-2.5 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-compass-3-line"></i>
                Découvrir les activités
              </Link>
              <Link
                to="/le-coin"
                className="px-5 py-2.5 rounded-md border border-background-300 text-sm font-semibold text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-chat-smile-3-line"></i>
                Aller sur Le Coin
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}